import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { AdminHeaderComponent } from '../../pages/admin/admin-home/admin-header/admin-header.component';
import { AdminFooterComponent } from '../../pages/admin/admin-home/admin-footer/admin-footer.component';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { Commons } from '../../shared/Commons';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    AdminHeaderComponent,
    AdminFooterComponent,
    CommonModule,
    RouterModule,
    TranslocoModule,
  ],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss'
})
export class AdminLayoutComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

  }

  ngOnInit(): void {
    if (this.isBrowser) {
      const body = document.querySelector('body');
      body?.classList.remove('with-bg');
    }
  }

  get isBrowser() {
    return Commons.isBrowser(this.platformId);
  }

}
